import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

// LanguageContext.jsx ile AYNI desen — tek farkı localStorage yerine /api/settings'ten (token'a
// bağlı) asenkron çekilmesi. Amaç: kullanıcının UTC ofseti (ve ileride eklenebilecek başka genel
// tercihler) gibi ayarları TEK bir yerden, uygulama genelinde paylaşmak — her bileşenin kendi
// başına /api/settings'e istek atmasına gerek kalmaz.
const UserSettingsContext = createContext(null);

const DEFAULT_UTC_OFFSET_MINUTES = 180; // UTC+3 — backend'deki userSettings.js varsayılanıyla AYNI

export function UserSettingsProvider({ token, children }) {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(() => {
    if (!token) { setSettings(null); return; }
    fetch('/api/settings', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(data => setSettings(data))
      .catch(() => {}); // sessizce yoksay — utcOffsetMinutes zaten varsayılana düşer
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);

  const utcOffsetMinutes = (() => {
    const raw = settings?.utc_offset_minutes;
    const n = parseFloat(raw);
    return isNaN(n) ? DEFAULT_UTC_OFFSET_MINUTES : n;
  })();

  return (
    <UserSettingsContext.Provider value={{ settings, utcOffsetMinutes, refresh }}>
      {children}
    </UserSettingsContext.Provider>
  );
}

export function useUserSettings() {
  const ctx = useContext(UserSettingsContext);
  if (!ctx) throw new Error('useUserSettings, UserSettingsProvider içinde kullanılmalı');
  return ctx;
}
